// extracted by mini-css-extract-plugin
export default {"user-type__input":"UserType_user-type__input__FbMq8"};